// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"terminal"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M13 19H21M3.5 17L8.5 12L3.5 7","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TerminalIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'terminal',
    ref,
    icon: element,
  },
));

TerminalIcon.displayName = 'TerminalIcon';

export default TerminalIcon;
